import { notifications } from "@mantine/notifications";

export function showSuccessNotification(message: string) {
  notifications.show({
    title: "Sucesso!",
    message,
    color: "green",
    autoClose: 5000,
  });
}
